import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-salon-dashboard-cards',
  templateUrl: './salon-dashboard-cards.component.html',
  styleUrls: ['./salon-dashboard-cards.component.css']
})
export class SalonDashboardCardsComponent {
  @Input() dashboard: any = {};
  @Input() lowStock: any[] = [];

  money(value: any): string {
    const numberValue = Number(value || 0);
    return `S/ ${numberValue.toFixed(2)}`;
  }
}
